import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { WorkflowHistoryResponse } from '../../models/workflow-history.model';

@Component({
  selector: 'app-workflow-history-dialog',
  templateUrl: './workflow-history-dialog.component.html',
  styleUrls: ['./workflow-history-dialog.component.scss']
})
export class WorkflowHistoryDialogComponent implements AfterViewInit {
  displayedColumns: string[] = [
    'moveDate',
    'fromPA',
    'toPA',
    'userName',
    'displayUserName',
    'workflowAction',
    'userComments'
  ];

  dataSource: MatTableDataSource<any>|undefined;
  instanceIdOptions: any;
  selectedInstanceID!: number;
  instanceData: WorkflowHistoryResponse|undefined;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
   @Inject(MAT_DIALOG_DATA) public data: WorkflowHistoryResponse[],
   private readonly dialogRef: MatDialogRef<WorkflowHistoryDialogComponent>
  ) {
    this.instanceIdOptions = this.data?.map(item => ({
      value: item.instanceID,
      text: item.instanceID,
    })) || [];

    if (this.instanceIdOptions.length > 0) {
      this.selectedInstanceID = this.instanceIdOptions[0].value;
      this.updateHistory(this.selectedInstanceID);
    } else {
      this.dataSource = new MatTableDataSource<any>([]);
    }
  }

  updateHistory(InstanceID: number){
    this.instanceData = this.data?.find(instance => instance.instanceID == InstanceID);
    this.dataSource = new MatTableDataSource(this.instanceData!.historyDataList);
  }
  ngAfterViewInit() {
    this.dataSource!.sort = this.sort;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
